import { useTranslation } from 'react-i18next';
import { GopherMark } from './GopherMark';

/** Non-interactive "Why Gopher?" easter-egg footer shared by desktop and mobile menus (D-08). */
export function WhyGopherNote() {
  const { t } = useTranslation();
  return (
    <div className="border-t border-[var(--border-default)] mt-1 flex items-start gap-2 px-3 py-2">
      <GopherMark size="24px" />
      <div className="min-w-0">
        <p className="text-[14px] font-semibold text-[var(--text-content-title)]">
          {t('assistant.whyGopher.title')}
        </p>
        <p className="text-[12px] leading-[1.5] text-[var(--text-content-sub-title)]">
          {t('assistant.whyGopher.body')}
        </p>
      </div>
    </div>
  );
}
